import React, { Component } from "react";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";

export default class RenderLander extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="lander">
              <h1>Training Slate</h1>
              <p>An app to help create training programs</p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/RenderLander.js